import { AppContext } from "App"
import React, { useContext } from "react"
import { Tab } from "static/tabs"
import { Form as FormHelper } from 'helpers/form'
import { Routing as RoutingHelper } from 'helpers/routing'
import { Reload as ReloadHelper } from 'helpers/reload'
import { Data as DataHelper } from 'helpers/data'
import { FormContext } from "components/utils/Form.context"
import Accordion from 'components/utils/Accordion/Accordion'
import Container from 'components/utils/GridContainer/GridContainer'
import CTAButton from "components/utils/Button/CTAButton"
import ReloadButton from "components/utils/Button/ReloadButton"
import Table from './Table'


const TableWithAdd: React.FC = () => {
  const { db, alert } = useContext(AppContext)

  const opt = {
    alert: {
      manager: alert,
      texts: {
        form: Tab.TeamOrganizations
      }
    }
  }

  const touchAll = async () => {
    if (!db?.teamOrganizations) return

    await FormHelper.touchAll({
      repository: db.teamOrganizations,
      optional: opt
    })
  }

  const reload = async () => {
    if (!db?.teamOrganizations) return

    return await ReloadHelper.reload({
      getAllFn: () => DataHelper.getAllTeamOrganizations(db),
      optional: opt
    })
  }

  return (
    <FormContext.Provider value={{ touch: touchAll }}>
      <Accordion
        content={
          <Container
            items={[
              <CTAButton
                key={'Container.CTA_New'}
                path={RoutingHelper.getTeamOrganizationDetailUrl({
                  teamOrganization: RoutingHelper.NewRecordSymbol
                })}
              >
                New
              </CTAButton>,
              <ReloadButton
                key={'Container.ReloadButton'}
                reloadFn={reload}
                from={opt.alert.texts.form}
              />
            ]}
          />
        }
        toggle={<Table />}
      />
    </FormContext.Provider>
  )
}

export default TableWithAdd
